/*
 * File: 客户模块-客户管理-详情-一页纸-重新生成
 */
<template>
    <el-dialog
        :visible="visible"
        title="重新生成"
        width="50vw"
        custom-class="paper-regenerate-dialog"
        destroy-on-close
        append-to-body
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="handleClose"
    >
        <el-form ref="ruleForm" :model="form" label-width="0">
            <el-form-item prop="checkList">
                <el-checkbox-group v-model="form.checkList">
                    <el-checkbox label="文本润色" />
                    <el-checkbox label="篇幅压缩" />
                </el-checkbox-group>
            </el-form-item>
            <el-form-item prop="content">
                <el-input
                    v-model="form.content"
                    type="textarea"
                    :rows="5"
                    :clearable="true"
                    placeholder="描述想要修改的内容，不填将基于原文案生成"
                />
            </el-form-item>
        </el-form>
        <span slot="footer">
            <el-button type="primary" size="small" @click="handleRegenerate">生成</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { ref, reactive } from '@vue/composition-api';

export default {
    props: {},
    setup(props, setupContext) {
        const emit = setupContext.emit;
        const visible = ref(false);
        const form = reactive({
            checkList: ['文本润色'],
            content: ''
        });

        const show = () => {
            visible.value = true;
            setupContext.root.$nextTick(() => {
                setupContext.refs.ruleForm.clearValidate();
            });
        };
        const handleClose = () => {
            visible.value = false;
            form.checkList = ['文本润色'];
            form.content = '';
        };
        // 生成
        const handleRegenerate = () => {
            setupContext.refs.ruleForm.validate((valid) => {
                if (valid) {
                    const user_feedback = form.checkList;
                    user_feedback.push(form.content);
                    emit('confirm', { user_feedback, mode: 'regenerate' });
                    handleClose();
                }
            });
        };
        return {
            visible,
            form,
            show,
            handleClose,
            handleRegenerate
        };
    }
};
</script>

<style lang="less">
.paper-regenerate-dialog {
    border-radius: 12px;
    .el-dialog__title {
        font-size: 16px;
        font-weight: 600;
    }
    .el-textarea__inner {
        background-color: #F2F3F5;
        color: #000;
        border-radius: 8px;
    }
    .el-button {
        border-radius: 8px;
        padding: 10px 32px;
    }
}
</style>
